/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização da section
 */
export default styled.section`
  padding: 16px 16px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 14px;

  p {
    padding: 12px;

    &:first-child {
      padding-top: 0;
      margin-top: 0;
    }
  }

  div.dashed {
    border: 0.5px dashed #000000;
    padding: 12px;
  }
`;
